import { GlButton, GlTooltipDirective } from '@gitlab/ui';
import { __ } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'ListItem',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        first: {
            type: Boolean,
            default: false,
            required: false
        },
        selected: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data () {
        return {
            isDetailsShown: false
        };
    },
    computed: {
        optionalClasses () {
            return {
                'gl-border-t-transparent': !this.first && !this.selected,
                'gl-border-t-default': this.first && !this.selected,
                'gl-border-b-default': !this.selected,
                '!gl-border-t-transparent': this.selected && !this.first,
                'gl-bg-blue-50 gl-border-blue-200': this.selected
            };
        },
        toggleDetailsIcon () {
            return this.isDetailsShown ? 'chevron-up' : 'chevron-down';
        },
        toggleDetailsLabel () {
            return this.isDetailsShown ? __('Hide details') : __('Show details');
        }
    },
    methods: {
        detailsSlots () {
            return Object.keys(this.glSlots()).filter((k)=>k.startsWith('details-'));
        },
        toggleDetails () {
            this.isDetailsShown = !this.isDetailsShown;
        }
    }
};
